module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/assessment_achievements/1_0ad543284e0e657a7362e1ee912e68cc.png";